<template>
	<nav class="topnav navbar navbar-expand shadow justify-content-between justify-content-sm-start navbar-light bg-white" id="sidenavAccordion">
		<router-link class="navbar-brand pe-3 ps-4 ps-lg-2" to="/">
			<!-- <img src="@/assets/img/company/Logo-PASTA BELLA -NEW-R_OFF.png" /> -->
			<img src="@/assets/img/company/actualProject/img-topnav.png" />
		</router-link>
		<button class="btn btn-icon btn-transparent-dark order-1 order-lg-0 me-2 ms-lg-2 me-lg-0" id="sidebarToggle">
			<fa icon="bars"></fa>
		</button>
		<!-- Navbar Search Input-->
		<!-- * * Note: * * Visible only on and above the md breakpoint-->
		<form id="searchForm" class="form-inline me-auto d-none d-lg-block me-3">
			<div class="input-group input-group-joined input-group-solid">
				<input id="searchInput" v-model="search" class="form-control mr-sm-2" :placeholder="`${$t('default.search.label')}`" type="search" aria-label="Search" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" />
				<!-- v-show="showSearch()" -->
				<div v-if="allResults.length > 0" id="searchDropdown" class="dropdown-menu dropdown-menu-end py-0 me-sm-n15 me-lg-0 o-hidden animated--fade-in-up show" aria-labelledby="searchInput" data-popper="none">
					<div class="dropdown-divider m-0"></div>
					<router-link v-for="result in allResults" :key="result.id" @click.native="closeSearch()" class="dropdown-item py-3" :to="{ name: result.redirect, params: { itemId: result.id } }">
						<div class="icon-stack bg-primary-soft text-primary me-4">
							<i :data-feather="result.type"></i>
						</div>
						<div>
							<div class="small text-gray-500">
								{{ result.value }}
							</div>
							{{ result.desc }}
						</div>
					</router-link>
					<div v-if="allResults.length == 0" class="dropdown-item py-3 justify-content-center">
						<div class="text-center me-4">
							{{ $t('default.no.results') }}
						</div>
					</div>
					<div class="dropdown-divider m-0"></div>

				</div>

				<div class="input-group-append">
					<div class="input-group-text">
						<fa icon="search"></fa>
					</div>
				</div>
			</div>
		</form>
		<!-- Navbar Items Access Rapide-->
		<ul class="navbar-nav align-items-left ml-auto">
			<li v-if="this.$store.getters.loggedIn && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_STOCK', 'ROLE_PROD'])" class="nav-item dropdown no-caret me-3 me-lg-4 dropdown-fonc">
				<a class="btn btn-icon bg-warning text-white fw-bold dropdown-toggle" id="navbarDropdownAccess" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" data-bs-target="#navbarDropdownAccess" aria-haspopup="true" aria-expanded="false">
					<fa icon="bolt"/>
				</a>
				<div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownAccess">
					<li v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_PROD'])" class="dropdown-header">
						{{ $t('sidenav.service.prod', 1) }}
					</li>
					<router-link v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_PROD'])" :to="{ name: 'servteamop'}" class="dropdown-item bg-primary text-white">
						<div class="dropdown-item-icon">
							<fa icon="random"/>
						</div>
						{{ $t('servteam.new') }}
					</router-link>
					<li v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_PROD'])" class="dropdown-divider"></li>
					<li v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_STOCK'])" class="dropdown-header">Stock</li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_STOCK'])" :to="{ name: 'servorder'}" class="dropdown-item bg-success text-white">
						<div class="dropdown-item-icon">
							<fa icon="sticky-note"/>
						</div>
						{{ $t('servorder.new') }}
					</router-link>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" class="dropdown-header">Vente</li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" :to="{ name: 'prodorder'}" class="dropdown-item bg-info text-white">
						<div class="dropdown-item-icon">
							<fa icon="cart-plus"/>
						</div>
						{{ $t('prodorder.new') }}
					</router-link>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" class="dropdown-divider"></li>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" class="dropdown-header">Tiers</li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" :to="{ name: 'prsperson', params: {type:2}}" class="dropdown-item bg-primary text-white">
						<div class="dropdown-item-icon">
							<fa icon="address-card"/>
						</div>
						{{ $t('prsperson.button.cl') }}
					</router-link>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" class="dropdown-divider"></li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" :to="{ name: 'prsperson', params: {type:1}}" class="dropdown-item bg-info text-white">
						<div class="dropdown-item-icon">
							<fa icon="address-book"/>
						</div>
						{{ $t('prsperson.button.ep') }}
					</router-link>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" class="dropdown-divider"></li>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" class="dropdown-header">Mouvements</li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:25, accId:1, typeAdd:'one'} }" class="dropdown-item bg-warning text-white">
						<div class="dropdown-item-icon">
							<fa icon="industry"/>
						</div>
						{{ $t('mvtmovement.button.debitfru') }}
					</router-link>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" class="dropdown-divider"></li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:7, accId:NaN, typeAdd:'one'} }" class="dropdown-item bg-primary text-white">
						<div class="dropdown-item-icon">
							<fa icon="calculator"/>
						</div>
						{{ $t('mvtmovement.button.debitpf') }}
					</router-link>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" class="dropdown-divider"></li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:6, accId:1, typeAdd:'vcc'} }" class="dropdown-item bg-info text-white">
						<div class="dropdown-item-icon">
							<fa icon="recycle"/>
						</div>
						{{ $t('mvtmovement.newvcc') }}
					</router-link>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" class="dropdown-divider"></li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:2, accId:NaN, typeAdd:'one'} }" class="dropdown-item bg-dark text-white">
						<div class="dropdown-item-icon">
							<fa icon="microchip"/>
						</div>
						{{ $t('mvtmovement.button.debitel') }}
					</router-link>

					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" class="dropdown-divider"></li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:17, accId:NaN, typeAdd:'one'} }" class="dropdown-item bg-warning text-white">
						<div class="dropdown-item-icon">
							<fa icon="signal"/>
						</div>
						{{ $t('mvtmovement.button.debitsp') }}
					</router-link>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" class="dropdown-divider"></li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:12, accId:NaN, typeAdd:'one'} }" class="dropdown-item bg-dark text-white">
						<div class="dropdown-item-icon">
							<fa icon="coffee"/>
						</div>
						{{ $t('mvtmovement.button.debitdj') }}
					</router-link>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" class="dropdown-divider"></li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:8, accId:NaN, typeAdd:'one'} }" class="dropdown-item bg-primary text-white">
						<div class="dropdown-item-icon">
							<fa icon="question-circle"/>
						</div>
						{{ $t('mvtmovement.button.debitaf') }}
					</router-link>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" class="dropdown-divider"></li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:21, accId:NaN, typeAdd:'one'} }" class="dropdown-item bg-info text-white">
						<div class="dropdown-item-icon">
							<fa icon="bus"/>
						</div>
						{{ $t('mvtmovement.button.debitft') }}
					</router-link>
					<li v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" class="dropdown-divider"></li>
					<router-link 
						v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER', 'ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:NaN, accId:NaN, typeAdd:'one'} }" class="dropdown-item bg-danger text-white">
						<div class="dropdown-item-icon">
							<fa icon="minus-circle"/>
						</div>
						{{ $t('mvtmovement.button.debit') }}
					</router-link>
					
				</div>
			</li>
		</ul>
		<!-- PROD -->
		<router-link 
			v-if="$store.getters.isAuthorized([ 'ROLE_PROD'])" :to="{ name: 'servteamop'}" class="btn btn-icon btn-success" :title="$t('servteam.new')">
			<fa icon="random"/>
		</router-link>
		<!-- STOCK -->
		<router-link 
			v-if="$store.getters.isAuthorized([ 'ROLE_STOCK'])" :to="{ name: 'servorder'}" class="btn btn-icon btn-success" :title="$t('servorder.new')">
			<fa icon="sticky-note"/>
		</router-link>
		<!-- VENTE -->
		<router-link 
			v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" :to="{ name: 'prodorder'}" class="btn btn-icon btn-success" :title="$t('prodorder.new')">
			<fa icon="cart-plus"/>
		</router-link>
		&ensp;
		<!-- <router-link 
			v-if="$store.getters.isAuthorized([ 'ROLE_MANAGER','ROLE_VENTE'])" :to="{ name: 'mvtmovement', params: {typeMvt:2, typeDep:NaN, accId:NaN, typeAdd:'one'} }" class="btn btn-icon btn-danger" :title="$t('mvtmovement.button.debit')"> 
			<fa icon="minus-circle"/>
		</router-link>
		&ensp; -->

		<!-- Navbar Items-->
		<ul class="navbar-nav align-items-center ml-auto">

			<!-- Fonctionalities Dropdown-->
			<li v-if="this.$store.getters.loggedIn && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE', 'ROLE_STOCK'])" class="nav-item dropdown no-caret me-3 me-lg-4 dropdown-fonc">
				<a class="btn btn-icon bg-primary text-white fw-bold dropdown-toggle" id="navbarDropdownInst" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" data-bs-target="#navbarDropdownInst" aria-haspopup="true" aria-expanded="false">
					<!-- Fonctionalités -->
					<fa icon="list"/>
					<!-- <div class="font-weight-500">Fonctionalités</div> -->
				</a>
				<div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownInst">
					<li v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE', 'ROLE_STOCK'])" class="dropdown-header">
						{{ $t('sidenav.service.prod', 1) }}
					</li>
					<router-link 
						v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE', 'ROLE_STOCK'])" 
						class="dropdown-item" :to="{ name: 'servorderlist' }">
						<div class="dropdown-item-icon">
							<fa icon="list"/>
						</div>
						{{ $t('servorder.list') }}
					</router-link>
					
					<li class="dropdown-divider"></li>
					<li class="dropdown-header">Stock</li>
					<router-link v-if="this.$store.getters.loggedIn" class="dropdown-item" :to="{ name: 'servtypeservstore'}">
						<div class="dropdown-item-icon">
							<fa icon="list"/>
						</div>
						{{ $t('servtypeserv.state') }}
						<!-- ETAT DES STOCKS -->
					</router-link>
					<li class="dropdown-divider"></li>
					<li class="dropdown-header">Vente</li>
					<router-link v-if="this.$store.getters.loggedIn" class="dropdown-item" :to="{ name: 'prodorderlist'}">
						<div class="dropdown-item-icon">
							<fa icon="list"/>
						</div>
						{{ $t('prodorder.list') }}
					</router-link>
					<li class="dropdown-divider"></li>
					<li class="dropdown-header" v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE'])">
						{{ $t('sidenav.mvt') }}
					</li>
					<router-link v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE'])" class="dropdown-item" :to="{ name: 'mvtaccount'}">
						<div class="dropdown-item-icon">
							<fa icon="list"/>
						</div>
						{{ $t('mvtaccount.list') }}
					</router-link>
					<li class="dropdown-divider" v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE'])"></li>
					<router-link v-if=" $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE'])" class="dropdown-item" :to="{ name: 'mvtmovementlist'}">
						<div class="dropdown-item-icon">
							<fa icon="list"/>
						</div>
						{{ $t('mvtmovement.list') }}
					</router-link>
					
				</div>
			</li>
			<!-- Language Dropdown-->
			<li v-if="i18n == 'Y' && this.$store.getters.loggedIn" class="nav-item dropdown no-caret me-3 me-lg-4 dropdown-fonc">
				<!-- btn-transparent-dark -->
				<a class="btn btn-icon bg-warning text-white fw-bold dropdown-toggle" id="navbarDropdownLang" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" data-bs-target="#navbarDropdownLang" aria-haspopup="true" aria-expanded="false">
					{{ language }}
				</a>
				<div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownLang">
					<button class="dropdown-item" @click="toggleLang('en')">
						English
					</button>
					<div class="dropdown-divider"></div>
					<button class="dropdown-item" @click="toggleLang('fr')">
						Français
					</button>

				</div>
			</li>
			
			<!-- User Dropdown-->
			<li v-if="this.$store.getters.loggedIn" class="nav-item dropdown no-caret me-3 me-lg-4 dropdown-user">
				<!-- btn-transparent-dark -->
				<a class="btn btn-icon bg-info text-white fw-bold dropdown-toggle" id="navbarDropdownUserImage" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" data-bs-target="#navbarDropdownUserImage" aria-haspopup="true" aria-expanded="false">
					<!--<img class="img-fluid" src="@/assets/img/illustrations/profiles/profile-1.png"/>-->
					<!-- {{this.$store.getters.prsInitial}} -->
					{{this.$store.getters.prsInfo.prsInitial}}
				</a>
				<div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownUserImage">
					<h6 class="dropdown-header d-flex align-items-center">
						<img class="dropdown-user-img" src="@/assets/img/illustrations/profiles/profile.jpg" />
						<div class="dropdown-user-details">
							<div class="dropdown-user-details-name">
								{{this.$store.getters.prsInfo.prsName}}
							</div>
						</div>
					</h6>

					<div v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE', 'ROLE_STOCK', 'ROLE_PROD'])" class="dropdown-divider"></div>
					<router-link v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI', 'ROLE_VENTE', 'ROLE_STOCK', 'ROLE_PROD'])" class="dropdown-item" :to="{ name: 'dashboard' }">
						<div class="dropdown-item-icon">
							<fa icon="dashboard" width="1em"/>
						</div>
						{{ $t('sidenav.dashboard', 1) }}
					</router-link>
					<div class="dropdown-divider"></div>
					<router-link class="dropdown-item" :to="{ name: 'profile' }">
						<div class="dropdown-item-icon">
							<fa icon="user" width="1em"/>
						</div> 
						{{ $t('topnav.account', 1) }}
					</router-link>
					<div class="dropdown-divider"></div>
					<router-link class="dropdown-item" :to="{ name: 'logout' }">
							<div class="dropdown-item-icon text-danger">
								<fa icon="sign-out" width="1em"/>
							</div> {{ $t('topnav.logout', 1) }}
					</router-link>

				</div>
			</li>
			<li v-else class="nav-item dropdown no-caret me-3 me-lg-4 dropdown-user">
				<button type="button" class="btn-sm btn-success" @click="this.$store.dispatch('auth')">
					<fa icon="sign-in" width="1em"/> {{ $t('topnav.login', 1) }}
				</button>
			</li>
		</ul> <!-- Navbar Items-->


	</nav>
</template>
<script>
	// const appModules = process.env.VUE_APP_MODULES || ''
	const searchMinimumSize = 2
	// import { langChangeMixin } from '@/mixins/languageScriptMixin'
	// import { localize } from 'vee-validate';
	export default {
		name: 'Topnav',
		// props: ['username'],
		data() {
			return {
				i18n: process.env.VUE_APP_I18N,
				language: 'fr',
				search: '',
				allResults: [],
				messages: [],
				alerts: [],
				appName: '',
				msgVisible: false,
				alertVisible: false,
				res: {}
			}
		},
		watch: {
			search: function (newVal) {
				if(newVal.length >= searchMinimumSize)
					this.sendSearch() 
			},
			msgVisible: function(newVal) {
				// if (newVal)
				// 	this.getMessages() 
			},
			alertVisible: function(newVal) {
				// if (newVal)
				// 	this.getAlerts() 
			}
		},
		created() {
			// this.appName = this.$store.getters.appConfig.appName;
			this.toggleLang(this.$store.getters.language)
		},
		methods: {
			toggleLang(lang) {
				this.$store.dispatch('updateLanguage', lang)
				this.$moment.locale(this.$store.getters.language)
				this.language = lang.substr(0, 2).toUpperCase()
				// Activate the new locale to vee validate
				// localize(this.$store.getters.language);
				/*switch(this.$store.getters.language) {
					case 'en':
						this.language = 'EN'
						break;
					case 'fr':
						this.language = 'FR'
						break;
					default:
						this.language = lang.substr(0, 2).toUpperCase()
				}*/
			},
			async sendSearch() {

			},
			async showSearch() {
				return true // this.search.length >= searchMinimumSize
			},
			closeSearch() {
				this.search = "";
			},
		}
		
	}
</script>
<style>
	.topnav .navbar-brand img {
    height: 3rem !important;
	}
</style>